import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var TwitterOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.51 20h-.08a10.87 10.87 0 01-4.65-1.09A1.38 1.38 0 013 17.47a1.41 1.41 0 011.16-1.18 6.63 6.63 0 002.54-.89 9.49 9.49 0 01-3.51-9.07 1.41 1.41 0 011-1.15 1.35 1.35 0 011.43.41 7.09 7.09 0 004.88 2.75 4.5 4.5 0 011.41-3.1 4.47 4.47 0 016.37.19.7.7 0 00.78.1A1.39 1.39 0 0121 7.13a6.66 6.66 0 01-1.28 2.6A10.79 10.79 0 018.51 20zm0-2h.08a8.79 8.79 0 009.09-8.59 1.32 1.32 0 01.37-.85 5.19 5.19 0 00.62-1 2.56 2.56 0 01-1.91-.85A2.45 2.45 0 0015 6a2.5 2.5 0 00-1.79.69 2.53 2.53 0 00-.72 2.42l.26 1.14-1.17.08a8.3 8.3 0 01-6.54-2.4 7.12 7.12 0 003.73 6.46l.95.54-.63.9a5.62 5.62 0 01-2.68 1.92A8.34 8.34 0 008.5 18zM19 6.65z",
    "data-name": "twitter"
  })));
});
TwitterOutline.displayName = 'TwitterOutline';
export var TwitterOutlineDimensions = {
  height: 24,
  width: 24
};